$(function(){
  /* スクロールで出現するヘッダーメニュー*/
	var scrollMenu = function() {
		var array = {
      '#page-top': 0,
			'#menu-1': 0,
			'#menu-2': 0,
			'#menu-3': 0,
         '#menu-4': 0
		};
		var $globalNavi = new Array();
		for (var key in array) {
			if ($(key).offset()) {
				array[key] = $(key).offset().top - 10;
				$globalNavi[key] = $('.follow-menu ul li a[href="' + key + '"]');
			}
		}
      /*
		$(window).scroll(function () {
			for (var key in array) {
				if ($(window).scrollTop() > array[key] - 50) {
					$('.follow-menu ul li a').each(function() {
						$(this).removeClass('active');
					});
					$globalNavi[key].addClass('active');
				}
			}
		});
  */
	}
	scrollMenu();
  
  /*スクロールで表示*/
$(window).on('load scroll', function(){
  if ($(window).scrollTop() > 300) {
   $('.follow-menu').fadeIn(400);
   } else {
    $('.follow-menu').fadeOut(400);
  }
  });
  
  /*下線スクロール*/
$(window).scroll(function (){
    $(".js-marker").each(function(){
      var position = $(this).offset().top; //ページの一番上から要素までの距離を取得
      var scroll = $(window).scrollTop(); //スクロールの位置を取得
      var windowHeight = $(window).height(); //ウインドウの高さを取得
      if (scroll > position - windowHeight){ //スクロール位置が要素の位置を過ぎたとき
        $(this).addClass('active'); 
      }
    });
});
  
      /*アコーディオンコンテンツ*/
	$('.accordion-contents dt').click(function(){
		$(this).next('dd').slideToggle();
     /*矢印の向きを変更*/
    $(this).toggleClass('open');
	});
  
  /*アンカーリンク付きタブ切り替え*/
  $('.view:eq(0)').addClass('active');
  $('.tab-tab').on('click',function(){
    $('.view').removeClass('active');
    $($(this).attr('href')).closest('.view').addClass('active');
  });
   // タブ クリックしたときの関数
  $('.tab-tab').click(function() {  
    $('.tab-tab').removeClass('tab_current');
    $(this).addClass('tab_current')
    });
  
  /*swiper スライド*/
  var swiper = new Swiper('.swiper-container', {
    navigation: { 
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,  
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false/*クリック後も動く*/
    },
    pagination: {   
      el: '.swiper-pagination',    
      type: 'bullets',   
      clickable: true,
    },
	});
  
});
